import * as React from "react";
import { Typography } from "antd";
import Report6PreviewApplicant from "./Report6PreviewApplicant";
import { TReport6ApplicantPresentationModel } from "../../../presenter/report/model/Report6ApplicantPresentationModel";

const Report6Preview = ({
  translate,
  applicants,
  title,
  subtitle
}: {
  translate?: any;
  applicants: TReport6ApplicantPresentationModel[];
  title?: string;
  subtitle?: string;
}) => {
  const renderApplicants = () => {
    let report6PreviewApplicants: JSX.Element[] = [];
    applicants.forEach((applicant: TReport6ApplicantPresentationModel) => {
      report6PreviewApplicants.push(
        <Report6PreviewApplicant
          key={`applicant-${applicant.id}`}
          translate={translate}
          applicant={applicant}
        />
      );
    });
    return report6PreviewApplicants;
  };

  return (
    <div>
      {title && (
        <Typography.Title style={{ fontSize: 25 }}>{title}</Typography.Title>
      )}
      {subtitle && (
        <Typography.Title style={{ fontSize: 20, marginBottom: 20 }}>
          {subtitle}
        </Typography.Title>
      )}
      {renderApplicants()}
    </div>
  );
};

export default Report6Preview;
